import { useState, useEffect } from "react";
import styles from "./Organization.module.css";
import ScrollReveal from "../Ui/ScrollReveal";
import apiService from "../../services/api";

function Organization() {
    const [imageUrl, setImageUrl] = useState("/image/about_organization.png");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchOrganization = async () => {
            try {
                const data = await apiService.getOrganization();
                if (data && (data.imageUrl || data.image)) {
                    setImageUrl(data.imageUrl || data.image);
                }
            } catch (error) {
                console.error('조직도 데이터 가져오기 실패:', error);
                // 에러 발생 시 기본 이미지 사용
            } finally {
                setLoading(false);
            }
        };

        fetchOrganization();
    }, []);

    return (
        <div className={styles.organizationWrap}>
            <ScrollReveal>
                <section className={styles.section01}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}>Organization</p>
                    <h2 className={styles.title}>조직도</h2>
                    <div className={styles.line}></div>
                </div>
                <div className={styles.organizationContainer}>
                    {loading ? (
                        <div>로딩 중...</div>
                    ) : (
                        <img src={imageUrl} alt="organization" />
                    )}
                </div>
            </section>
            </ScrollReveal>
        </div>
    )
}

export default Organization;